import moment from 'moment';

export enum HighlightTypes {
  Undefined = 0,
  Commissions = 1,
  Deposits = 2,
  Withdrawals = 3,
  Volume = 4,
  VolumeLots = 5,
  Profit = 6,
  Clients = 7,
  TradingAccounts = 8,
  NetDeposits = 9,
  Loss = 10,
  InternalTransferIn = 11,
  InternalTransferOut = 12,
  NetInternalTransfer = 13,
}

export enum ClientFilterType {
  All = 0,
  Direct = 1,
  SubPartnership = 2,
}

export interface AggregatedValues {
  accounts: number;
  accountsPercent: number;
  clients: number;
  clientsPercent: number;
  commissions: number;
  commissionsChangePercent: number;
  deposits: number;
  depositsChangePercent: number;
  internalTransferIn: number;
  internalTransferInChangePercent: number;
  internalTransferOut: number;
  internalTransferOutChangePercent: number;
  updatedAt: string;
  loss: number;
  lossChangePercent: number;
  netDeposits: number;
  netDepositsChangePercent: number;
  netInternalTransfer: number;
  netInternalTransferChangePercent: number;
  profit: number;
  profitChangePercent: number;
  volume: number;
  volumeChangePercent: number;
  volumeLots: number;
  volumeLotsChangePercent: number;
  withdrawals: number;
  withdrawalsChangePercent: number;
}

export interface DashboardValues {
  activeClients: number;
  activeTradingAccounts: number;
  cashback: string;
  inactiveClients: number;
  inactiveTradingAccounts: number;
  totalClients: number;
  totalLinks: number;
  totalTradingAccounts: number;
}

export interface HighlightDataItem {
  period: string;
  amount: number;
}

const getDates = (startDate: Date, stopDate: Date): string[] => {
  const dates: string[] = [];

  let currentDate = moment(startDate).startOf('day');
  const lastDate = moment(stopDate).startOf('day');

  while (currentDate.isSameOrBefore(lastDate, 'day')) {
    dates.push(currentDate.format('YYYY-MM-DD'));

    currentDate = currentDate.clone().add(1, 'day');
  }

  return dates;
};

export const checkDataExist = (data: HighlightDataItem[] | null | undefined, fromDate: Date, toDate: Date): HighlightDataItem[] => {
  const dates = getDates(fromDate, toDate);

  const safeData = Array.isArray(data) ? data : [];

  const valuesByDate = safeData.reduce<Record<string, number>>((result, item) => {
    if (!item || !item.period) {
      return result;
    }

    const period = moment(item.period);

    if (!period.isValid()) {
      return result;
    }

    result[period.format('YYYY-MM-DD')] = typeof item.amount === 'number' ? item.amount : 0;

    return result;
  }, {});

  return dates.map((date) => ({
    period: date,
    amount: valuesByDate[date] ?? 0,
  }));
};
